import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./layout.css";
import "./i18n/index.js";
import { BrowserRouter } from "react-router-dom";
import StoreProvider from "./context/themeContext";
import reportWebVitals from "./reportWebVitals";
import ThemeConfig from "./themeConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <StoreProvider>
      <BrowserRouter>
        <ThemeConfig>
          <App />
        </ThemeConfig>
      </BrowserRouter>
    </StoreProvider>
  </React.StrictMode>
);

reportWebVitals();
